module.exports = __webpack_public_path__ + "static/img/dengyunze.7ee23b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/touxiang/dengyunze.png
// module id = GLj5
// module chunks = 0